import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 20.0001L1.78477 10.6124C0.628311 9.43426 0 7.87582 0 6.21534C0 4.55485 0.637417 2.99641 1.78477 1.8183C4.17053 -0.602846 8.04056 -0.602846 10.4172 1.8183L19.6324 11.2061L11 20.0001V20.0001ZM6.10099 1.85541C5.00828 1.85541 3.90646 2.28213 3.06871 3.13556C2.25828 3.96116 1.81209 5.05578 1.81209 6.22461C1.81209 7.39344 2.25828 8.48806 3.06871 9.31367L10.9909 17.3842L17.0464 11.2153L9.13328 3.12628C8.29553 2.27285 7.20281 1.84613 6.10099 1.84613V1.85541Z",
  class: "icon-favorite__border"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.3842 2.69944C15.0597 1.4564 17.4181 1.58627 18.9297 3.12616C19.7401 3.95176 20.1863 5.04638 20.1863 6.21521C20.1863 7.15213 19.8858 8.0334 19.3486 8.77551L20.6598 10.1113C21.534 9.00742 22.0075 7.65306 22.0075 6.21521C22.0075 4.55473 21.3701 2.99629 20.2228 1.81818C18.0009 -0.445269 14.4769 -0.593692 12.082 1.37291L13.3933 2.70872L13.3842 2.69944Z",
  class: "icon-favorite__border"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 20.0001L1.78477 10.6124C0.628311 9.43426 0 7.87582 0 6.21534C0 4.55485 0.637417 2.99641 1.78477 1.8183C4.17053 -0.602846 8.04056 -0.602846 10.4172 1.8183L19.6324 11.2061L11 20.0001V20.0001Z",
  class: "icon-favorite__filled"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0742 1.37291C14.4691 -0.593692 17.9931 -0.445269 20.2149 1.81818C21.3714 2.99629 21.9997 4.55473 21.9997 6.21521C21.9997 7.65306 21.5262 9.00742 20.652 10.1113L12.0742 1.37291Z",
  class: "icon-favorite__filled"
}, null, -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconFavorite',
  props: {
  isFilled: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    fill: "none",
    class: _normalizeClass(["icon-favorite", { 'icon-favorite--filled': __props.isFilled }])
  }, _hoisted_5, 2))
}
}

})